module.exports = __webpack_public_path__ + "static/img/张靖皋1.c8230978.png";